var map = {
	"./1.jpg": 7829,
	"./10.jpg": 5145,
	"./11.jpg": 796,
	"./2.jpg": 7338,
	"./3.jpg": 9495,
	"./4.jpg": 5084,
	"./5.jpg": 3081,
	"./6.jpg": 4414,
	"./7.jpg": 251,
	"./8.jpg": 8496,
	"./9.jpg": 9421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;